
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { uiStore } from "@/store/store";

@Component
export default class Error extends Vue {
  get errors() {
    return uiStore.unrecoverableErrorMessages;
  }
}
